export type ErrorResponse<T = string> = {
  code: T; // NOTE: type not used yet here, but this is how its defined in the service as well
  message: string;
};

export function isErrorResponse(obj: any): obj is ErrorResponse {
  if (!obj) return false;
  return typeof obj.message === "string" && typeof obj.code === "string";
}
